import logo from './logo.svg';
import './App.css';

import React, { useState, useLayoutEffect } from 'react';

import { BrowserRouter, NavLink, Routes, Route, Navigate, useLocation} from 'react-router-dom';

// import Header from './navigate/Header';
// import Footer from './components_e/Footer/Footer';
import CardsLayout from './features/home/components/CardsLayout';
import AppRouter from './app/router';
import { AuthProvider } from './shared/auth/AuthProvider';

function Wrapper({ children }) {
  const location = useLocation();
  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [location.pathname]);
  return children;
}

export default function App() {
  return (
    <div className="page-container">
      <BrowserRouter>
        <AuthProvider>
          <Wrapper>
            <AppRouter />
          </Wrapper>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
